import React, { useState } from 'react'
import { Switch, CircularProgress } from '@mui/material'
import showToast from '../../../Common/SweetAlert/ToastAlert/index'
import { EVENT_STATUS } from '../../../../constant/Event'
import { useAppDispatch, useAppSelector } from '../../../../redux/store'
import { updateEvent } from '../../../../redux/event/manageEvents/actions'
import { selectUserTeamMemberInfo } from '../../../../redux/auth/selector'

interface EventRegistrationActionProps {
  body: any
}

const EventRegistrationAction: React.FC<EventRegistrationActionProps> = ({ body }) => {
  const teamMemberDetails = useAppSelector(selectUserTeamMemberInfo)
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const handleStatusToggle = async () => {
    setIsLoading(true)
    let newStatus = ''

    newStatus = body.status === EVENT_STATUS.ACTIVE ? EVENT_STATUS.INACTIVE : EVENT_STATUS.ACTIVE
    try {
      await dispatch(
        updateEvent({
          id: Number(body.id),
          status: newStatus,
          updatedBy: {
            email: teamMemberDetails.email,
            workdayId: teamMemberDetails.workdayId,
          },
        }),
      )
    } catch (err) {
      showToast('error', 'Error updating event status.')
      console.error('Error updating event status:', err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {!isLoading ? (
        <Switch
          id='registration-switch'
          checked={body.status === EVENT_STATUS.ACTIVE}
          onChange={handleStatusToggle}
          disabled={body.isCompleted || isLoading}
          color='primary'
        />
      ) : (
        <CircularProgress size={24} />
      )}
    </>
  )
}

export default EventRegistrationAction
